import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-funnel-sharp",
  "use": "icon-funnel-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-funnel-sharp\"><title>Funnel</title><path d=\"M0 48l192 240v128l128 48V288L512 48H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol